// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"64616b1e","354":"085f09e3","418":"22c6f7a1"}[chunkId] + ".js";
};